import React from 'react'
import { Icon } from 'labguard-cdk'

const AcknowledgeAlarmIcon = domProps => <Icon icon="check" {...domProps} transform="shrink-8" mask="bell" />

AcknowledgeAlarmIcon.propTypes = {}

export default AcknowledgeAlarmIcon
